module.exports = __webpack_public_path__ + "static/media/Sharp-LQ190E1LX75T-Mechanical-Drawing-clean.c49e0c90.png";